










































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import chatModule from "@/store/modules/chat-module";
import { ChatMensajeDto } from "@/shared/dtos/chat/chat-mensaje.dto";
import { renderMarkdown } from "@/shared/utils/markdown";
import { RouterNames } from "@/router/routernames";

@Component
export default class ChatPopup extends Vue {
  @Prop({ default: false }) public mostrar!: boolean;

  public mensajeActual: string = "";

  public get mensajes() {
    return chatModule.mensajes;
  }
  public get enviando() {
    return chatModule.enviando;
  }
  public get ultimaRespuesta() {
    return chatModule.ultimaRespuesta;
  }

  @Watch("mostrar")
  public onMostrarChanged(val: boolean) {
    if (val) {
      this.scrollAbajo();
      this.evaluarSugerenciaContextual();
    }
  }

  @Watch("mensajes")
  public onMensajesChanged() {
    this.scrollAbajo();
  }

  public renderMd(text: string): string {
    return renderMarkdown(text);
  }

  public expandir() {
    this.$emit("cerrar");
    if (this.$route.name !== RouterNames.ia_suite) {
      this.$router.push({ name: RouterNames.ia_suite });
    }
  }

  public async enviar() {
    const texto = this.mensajeActual.trim();
    if (!texto) { return; }
    this.mensajeActual = "";

    // Garantizar que tenemos una conversación
    if (chatModule.conversacionActualId === 0) {
      chatModule.nuevaConversacion();
    }

    chatModule.addMensajeLocal(new ChatMensajeDto({
      id: Date.now(),
      id_conversacion: chatModule.conversacionActualId,
      rol: "user",
      contenido: texto,
    }));
    this.scrollAbajo();

    await chatModule.enviarMensaje({
      conversacionId: chatModule.conversacionActualId,
      mensaje: texto,
    });

    const convId = chatModule.ultimaRespuesta.conversacionId || chatModule.conversacionActualId;
    if (convId > 0) {
      chatModule.setConversacionActual(convId);
      await chatModule.getMensajes(convId);
      await chatModule.getConversaciones();
    }
  }

  public async evaluarSugerenciaContextual() {
    // Si ya hay mensajes, no saludamos de nuevo para no interrumpir
    if (this.mensajes.length > 0) return;

    const rutaActual = this.$route.name || this.$route.path;
    
    // Crear conversación si no hay
    if (chatModule.conversacionActualId === 0) {
      chatModule.nuevaConversacion();
    }

    // Mensaje de sistema oculto para forzar sugerencia
    const promptOculto = `El usuario acaba de abrir el asistente IA en la vista/ruta: '${rutaActual}'. 
Eres el asistente de la tienda. Salúdale brevemente (1 o 2 líneas) y dale 2 sugerencias claras de lo que puedes ayudarle a hacer en esta pantalla o en general. Usa viñetas en formato Markdown.`;

    await chatModule.enviarMensaje({
      conversacionId: chatModule.conversacionActualId,
      mensaje: promptOculto,
      // No lo guardamos localmente como 'user' para que el usuario solo vea la respuesta
    });

    const convId = chatModule.ultimaRespuesta.conversacionId || chatModule.conversacionActualId;
    if (convId > 0) {
      chatModule.setConversacionActual(convId);
      await chatModule.getMensajes(convId);
      await chatModule.getConversaciones();
    }
  }

  public scrollAbajo() {
    this.$nextTick(() => {
      const el = this.$refs.mensajesArea as HTMLElement;
      if (el) { el.scrollTop = el.scrollHeight; }
    });
  }
}
